<div class="_head">
  <button (click)="clearCache()" [attr.disabled]="loading ? true : null">Clear cache</button>
  <button (click)="fetch()" [attr.disabled]="loading ? true : null">Fetch</button>
  <input [(ngModel)]="funds" placeholder="funds" />
  <input [(ngModel)]="documentId" placeholder="document cuid" />
</div>

<div class="_content">
  @if (path && path.length > 0) {
    <div class="_path">{{path}}</div>
    <hr>
  }

  @if (prompts) {
    <details>
      <summary>Prompts</summary>
      <wct-json [value]="prompts" />
    </details>
  }

  @if (inputControls) {
    <details>
      <summary>Input Controls</summary>
      <wct-json [value]="inputControls" />
    </details>
  }

  @if (loading) {
    >> loading <<
  } @else {
    <hr>

    <details open>
      <summary>Reports</summary>
      @for (report of reports; track $index) {
        <div class="_report">
          <div>Report [{{ $index }}] - {{ report.name }}<span class="_right">{{ report.id }}</span></div>

          <div>Elements:</div>
          <ul>
            @for (element of report.elements; track $index) {
              <li>
                <div>{{ element.element.name }} [<pre class="_inline">{{ element.element.name | visualizeSpaces }}</pre>]</div>

                <details>
                  <summary>Raw element</summary>
                  <pre>{{ element.element | json }}</pre>
                </details>

                <details>
                  <summary>Raw renderable</summary>
                  <pre>{{ element.renderable | json }}</pre>
                </details>

                <details>
                  <summary>Element</summary>
                  <div class="_wrapper">
                    <wct-element-host [element]="element"/>
                  </div>
                </details>
              </li>
            } @empty {
              No elements or error
            }
          </ul>
        </div>

        @if (!$last) {
          <hr>
        }
      }
    </details>
  }
</div>
